import { db } from '../firebaseConfig';
import { collection, getDocs, getDoc, addDoc, updateDoc, deleteDoc, doc, query, orderBy } from 'firebase/firestore';

const COLLECTION_NAME = "blogs";

export const getBlogPosts = async () => {
  try {
    const q = query(collection(db, COLLECTION_NAME), orderBy("date", "desc"));
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
  } catch (error) {
    console.error("Error getting blog posts:", error);
    throw error;
  }
};

export const getBlogPostById = async (id) => {
  try {
    const docRef = doc(db, COLLECTION_NAME, id);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      return { id: docSnap.id, ...docSnap.data() };
    } else {
      throw new Error("Post not found");
    }
  } catch (error) {
    console.error("Error getting blog post:", error);
    throw error;
  }
};

export const addBlogPost = async (post) => {
  try {
    const newPost = {
      ...post,
      date: post.date || new Date().toISOString(),
      views: post.views || 0
    };
    const docRef = await addDoc(collection(db, COLLECTION_NAME), newPost);
    return { id: docRef.id, ...newPost };
  } catch (error) {
    console.error("Error adding blog post:", error);
    throw error;
  }
};

export const updateBlogPost = async (id, post) => {
  try {
    const docRef = doc(db, COLLECTION_NAME, id);
    await updateDoc(docRef, post);
    return { message: "Blog post updated" };
  } catch (error) {
    console.error("Error updating blog post:", error);
    throw error;
  }
};

export const deleteBlogPost = async (id) => {
  try {
    const docRef = doc(db, COLLECTION_NAME, id);
    await deleteDoc(docRef);
    return { message: "Blog post deleted" };
  } catch (error) {
    console.error("Error deleting blog post:", error);
    throw error;
  }
};
